/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_Vehicle_Count_PositiveInputs */

const en_clients_validation_vehicle_count_positive = /** @type {(inputs: Clients_Validation_Vehicle_Count_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of vehicles must be a positive whole number.`)
};

const pt_br2_clients_validation_vehicle_count_positive = /** @type {(inputs: Clients_Validation_Vehicle_Count_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de veículos deve ser um número inteiro positivo.`)
};

/**
* | output |
* | --- |
* | "Number of vehicles must be a positive whole number." |
*
* @param {Clients_Validation_Vehicle_Count_PositiveInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_vehicle_count_positive = /** @type {((inputs?: Clients_Validation_Vehicle_Count_PositiveInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Vehicle_Count_PositiveInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_vehicle_count_positive(inputs)
	return pt_br2_clients_validation_vehicle_count_positive(inputs)
});